import { ChartType } from '@constants/constants';
import { AxisTransformer, TooltipConfig } from './utils';

export enum CustomChartFilters {
  SELECT_ALL = 'Select All',
  INVERSE = 'Inverse',
}

export enum MultiChartType {
  LINE_CHART = 'LINE_CHART',
  BAR_CHART = 'BAR_CHART',
}

/**
 * Underwriting Charts/Tables API Response Types
 */

export interface ChartPoint {
  x: string;
  y: string | null;
}

// Interface for series data (line charts, etc.)
export interface ChartSeries {
  name: string;
  points: ChartPoint[];
}

export interface BoxPlotChartPoint extends ChartPoint {
  count: string;
  min: string;
  max: string;
  q1: string;
  median: string;
  q3: string;
  mean: string;
}

export interface BoxPlotChartSeries {
  name: string;
  points: BoxPlotChartPoint[];
}

// Interface for chart data with type (for combo charts)
export interface TypedChartData {
  type: MultiChartType;
  points: ChartPoint[];

  /* TODO: Add from Backend */
  name?: string;
}

export interface BubbleChartPoint extends ChartPoint {
  x: string;
  y: string;
  label: string;
  weight: string;
}

export interface BubbleChartSeries extends ChartSeries {
  points: BubbleChartPoint[];
}

// Union type for different data structures
type ApiChartData =
  | ChartSeries[]
  | TypedChartData[]
  | BubbleChartSeries[]
  | (string | number)[][]
  | BoxPlotChartSeries[];

// Metadata interface (parsed from JSON string)
export interface UnderwritingChartMetadata {
  chartType: ChartType;
  tabId: string;
  tabLabel: string;
  threshold?: number;
  xAxisLabel?: string;
  yAxisLabel?: string;
  xAxisTransform?: AxisTransformer; // e.g., 'percentage', 'currency'
  yAxisTransform?: AxisTransformer; // e.g., 'percentage', 'currency'
  thresholdLabel?: string;
  y1AxisLabel?: string;
  y1AxisTransform?: AxisTransformer;
  tooltipConfigs?: TooltipConfig;
  definitions: { label: string; description: string }[];
}

interface ChartResult {
  data: ApiChartData;
  columns: string[];
}

interface ChartResponseData {
  result: ChartResult;
  metadata: string; // JSON string that should be parsed to ChartMetadata
  name: string;
  rowOrder: number;
  columnOrder: number;
}

export interface UnderwritingChartsApiResponse {
  code: number;
  message: string;
  data: ChartResponseData;
}
